import React from 'react';
import "./empty.module.less";
import classnames from 'classnames';
var emptyStatusMap = {
  'empty': {
    url: 'https://static.zpimg.cn/public/common-image/empty.svg',
    text: '暂无数据'
  },
  '404': {
    url: 'https://static.zpimg.cn/public/common-image/404.svg',
    text: '页面不存在'
  },
  '403': {
    url: 'https://static.zpimg.cn/public/common-image/403.svg',
    text: '页面不存在'
  },
  '500': {
    url: 'https://static.zpimg.cn/public/common-image/500.svg',
    text: '网站出错了'
  },
  'networkError': {
    url: 'https://static.zpimg.cn/public/common-image/networkError.svg',
    text: '网络异常'
  },
  'noPermission': {
    url: 'https://static.zpimg.cn/public/common-image/noPermission.svg',
    text: '暂无权限'
  }
};
var Empty = function Empty(props) {
  var src = props.src,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? 'empty' : _props$type,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    imgClassName = props.imgClassName,
    className = props.className;
  var imgSize = size === 'small' ? 'small' : 'normal';
  var getText = function getText() {
    var _emptyStatusMap$type;
    return text || ((_emptyStatusMap$type = emptyStatusMap[type]) === null || _emptyStatusMap$type === void 0 ? void 0 : _emptyStatusMap$type.text) || '暂无数据';
  };
  var getImgSrc = function getImgSrc() {
    var _emptyStatusMap$type2;
    return src || ((_emptyStatusMap$type2 = emptyStatusMap[type]) === null || _emptyStatusMap$type2 === void 0 ? void 0 : _emptyStatusMap$type2.url) || 'https://static.zpimg.cn/public/common-image/empty.svg';
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('wt-component-empty', className ? className : '')
  }, /*#__PURE__*/React.createElement("img", {
    className: classnames(imgClassName ? imgClassName : '', imgSize),
    src: getImgSrc()
  }), /*#__PURE__*/React.createElement("div", {
    className: "wt-component-empty-text"
  }, getText()));
};
export default Empty;